import { Fragment } from 'react';
import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { Container, Divider, TableHeader } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { upperFirst } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { EnterpriseProfilePrivileges, Role, RoleGetResult } from '@mews-commander/data-access';
import { EnterpriseProfilePrivilegesEnumNames } from '@mews-commander/legacy-data-structures';
import { PrivilegeName } from '../PrivilegeName';

export const PrivilegesList = ({ role }: { role: RoleGetResult | Role }) => {
    const activePrivileges = pipe(
        Object.keys(role.privileges),
        array.filterMap((privilege) =>
            role.privileges[privilege as keyof EnterpriseProfilePrivileges] === true
                ? option.some(privilege)
                : option.none
        )
    );

    return (
        <>
            <TableHeader title={<LocalizedText textKey={TextKey.Privileges} />} subTitle={activePrivileges.length} />
            {activePrivileges.map((privilege) => (
                <Fragment key={privilege}>
                    <Container padding={['200', '100']}>
                        <PrivilegeName privilege={upperFirst(privilege) as EnterpriseProfilePrivilegesEnumNames} />
                    </Container>
                    <Divider />
                </Fragment>
            ))}
        </>
    );
};
